import { AnimationTriggerMetadata, animate, state, style, transition, trigger } from '@angular/animations';

export const EnterLeaveFadeInOutAnimation: AnimationTriggerMetadata[] = [
	trigger('enterLeaveFadeInOut', [
		state('*', style({ opacity: 1 })),
		state('void', style({ opacity: 0 })),
		transition(':leave', animate('0.3s')),
		transition(':enter', animate('0.3s'))
	])
];

export const EnterFadeInAnimation: AnimationTriggerMetadata[] = [
	trigger('enterFadeIn', [state('*', style({ opacity: 1 })), state('void', style({ opacity: 0 })), transition(':enter', animate('0.3s'))])
];
